/** Raise a new feedback item. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { FeedbackForm } from "@/features/feedback/components/feedback-form";

export const Route = createFileRoute("/_app/feedback/new")({
  beforeLoad: () => {
    const { me, can } = useAuth.getState();
    if (!me?.features?.feedback || !can("feedback.view"))
      throw redirect({ to: "/" });
    if (!can("feedback.create")) throw redirect({ to: "/feedback" });
  },
  component: FeedbackForm,
});
